import * as React from 'react'
import { withCobrand } from '../modules/cobrand'
import './footer.css'


@withCobrand
class Footer extends React.Component<any, any> {

    render() {
        const year = new Date().getFullYear();
        return (
            <div className="footer white-text">
                <div className="container">
                    <div className="row">
                        <div className="col-md-14 text-center">
                            <div>
                                <p><a href="https://www.chu.com.au/resource/compliments/" target="_blank">Compliments</a> | <a href="https://www.chu.com.au/resource/complaints-and-disputes/ " target="_blank"> Complaints and Dispute Resolution</a>  </p>
                                <p>CHU Underwriting Agencies Pty Ltd (ABN&nbsp;18&nbsp;001&nbsp;580&nbsp;070, AFS Licence&nbsp;No:&nbsp;243261) acts under a binding authority as agent of the insurer QBE Insurance (Australia) Limited (ABN&nbsp;78&nbsp;003&nbsp;191&nbsp;035, AFS Licence&nbsp;No:&nbsp;239545).</p>
                                <p>Terms, conditions, limits and exclusions apply to the products referred to above. Any advice on this website is general advice only and has been prepared without taking into account your objectives, financial situation or needs. Before making a decision to acquire any product(s) or to continue to hold any product we recommend that you consider whether it is appropriate for your circumstances and read the relevant Product Disclosure Statement (‘PDS’), Financial Services Guide (‘FSG’), and the Target Market Determination (‘TMD’) which can be viewed on this website or obtained by contacting CHU directly.</p>
                                <p>Copyright <i className="fa fa-copyright" aria-hidden="true"></i> {new Date().getFullYear()} CHU Underwriting Agencies Pty Ltd</p>
                            </div>

                            { (this.props.cobrand && this.props.cobrand.footer) &&
                            <div dangerouslySetInnerHTML={this.props.cobrand.footer} ></div>
                            }
  
  
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


export default Footer;





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/footer.tsx